import React, { Component } from 'react';
import { connect } from 'react-redux';
import Service from '../../../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { BasicLazyParams } from '../../../../utile';
import Authentication from '../../../session';

import { ActiveTag, BoardsIconInActive, CancelRed, CrossInBox, GreenCheck, InactiveTag, PopupGreeTick } from '../../../svgIcons';
import LoadingComponent from '../../../loadingComponent';
import { baseUrlAdmin } from '../../../../store/apiConstants';
import withRouter from '../../../lib/withRouter';
import { RadioButton } from 'primereact/radiobutton';
import ClassetStudentSearch from '../../../../classetComponents/classetStudentSearch';
import { debounce } from 'lodash';
import BranchToSectionApprovalHierarchy from '../../../BaseDropdownComponents/BranchToSectionApprovalHierarchy';
import { getBranchesLatest } from '../../../../store/actions';
// import ClassetStudentSearchFilter from '../../../Search/ClassetStudentSearchFilter';


import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import boards from '../../../boardsMaster/boards';

// const searchTypeOptions = [
//     { label: 'Student Name', value: 'studentName' },
//     { label: 'Enrollment Number', value: 'enrollmentNumber' }
// ];

class StudentStatusChangeRequests extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            lazyParams: BasicLazyParams,
            changeRequests: [],
            totalRecords: 0,
            isDialogOpenForApproveStudent: false,
            isRejectTransferDialogOpen: false,
            rowData: {},
            dropdownsData: {},
            flagForTransfer: null,
            searchValue: '',
            searchLevel: 1,
            // searchType: searchTypeOptions[0].value,
            dropdownsDilogData: {},
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'firstName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'lastName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'enrollmentId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'contactPersonName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'parentContactNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                'totalFee': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                'refundRaisedAmt': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
            },
            globalFilterValue: '',
        };
        this.debouncedApiCall = debounce(this.filterUsersData, 500);
        this.service = new Service();
    }

    setDropdownValues = (dropdownsData) => {
        this.setState({ dropdownsData },
            () => {
                // Check if branchIds is empty array and prevent API call
                if (!this.state?.dropdownsData?.branchIds ||
                    (Array.isArray(this.state?.dropdownsData?.branchIds) && this.state?.dropdownsData?.branchIds.length === 0)) {
                    console.log('No branches selected, skipping API call');
                    this.setState({
                        isLoading: false,
                        studentInfo: [],
                        studentstotalRecords: 0
                    });
                    return;
                }

                // if (this.searchLevel === 1)
                //     this.filterUsersData()
                // else
                this.filterUsersData()
            }

        );
    };


    filterUsersData = () => {
        this.setState({ isLoading: true, changeRequests: [] });

        // Always default dropdownsData to an object
        const { lazyParams, searchLevel, searchType, searchValue } = this.state;
        const dropdownsData = this.state.dropdownsData || {};

        const url = `${baseUrlAdmin}/statusChange/get/all?academicYear=${localStorage.getItem('userAcademicYear')}`;
        let payload = {
            sectionId: searchLevel === 1 ? dropdownsData.sectionId : undefined,
            isUserNameSearch: searchLevel === 2 && searchType === 'studentName',
            username: searchValue,
            assignedHeirarchy: dropdownsData.heirarchy,
            branchIds: dropdownsData.branchIds || [],
            boardId: dropdownsData.boardIds || [],
            gradeId: dropdownsData.classIds || [],
            sectionId: dropdownsData.sectionId || '',
            studentId: dropdownsData.studentIds,
        };

        // if (searchLevel === 1 && !dropdownsData.sectionId) {
        //     payload.branchIds = dropdownsData.branchIds ?? [];
        // }





        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res?.status && res.res?.status) {
                    this.setState({
                        isLoading: false,
                        changeRequests: res.res?.data || [],
                        totalRecords: res.res?.totalRecords || 0
                    });
                } else {
                    throw new Error(res.errMessage || 'An error occurred');
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            });
    };

    componentDidMount() {
        if (this.state.dropdownsData?.sectionId) {
            this.filterUsersData();
        }
        // this.props.getBranchesLatest();
    }

    onPage = (event) => {
        this.setState(
            (prevState) => ({
                lazyParams: { ...prevState.lazyParams, ...event }
            }),
            this.filterUsersData
        );
    };

    onSort = (event) => {
        this.setState(
            (prevState) => ({
                lazyParams: { ...prevState.lazyParams, ...event }
            }),
            this.filterUsersData
        );
    };

    onFilter = (event) => {
        event['first'] = 0;
        this.setState(
            (prevState) => ({
                lazyParams: { ...prevState.lazyParams, filters: event.filters }
            }),
            this.filterUsersData
        );
    };

    updateTransfer = (approveStatus) => {
        const { rowData, dropdownsData } = this.state;
        if (rowData && Object.keys(rowData).length) {
            const payload = {
                ...rowData,
                approveStatus,
                statusChangeRequest: 'DONE',
                handledBy: rowData?.handledBy || [],
                levelAndBranchDetails: this.state.dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id == rowData?.branchId)

            };
            const url = `${baseUrlAdmin}/statusChange/update`;

            this.service
                .post(url, payload, true)
                .then((res) => {
                    if (res?.status && res?.res?.status) {
                        this.setState({
                            isDialogOpenForApproveStudent: false,
                            isRejectTransferDialogOpen: false
                        });
                        this.toast.show({ severity: 'success', summary: `Successfully ${this.state.flagForTransfer}ED`, detail: res.message, life: 3000 });
                        this.filterUsersData();
                    } else {
                        throw new Error(res.errMessage || 'An error occurred');
                    }
                })
                .catch((error) => {
                    this.toast.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
                });
        } else {
            this.toast.show({ severity: 'error', summary: 'No Record Selected', detail: 'Please select at least one record', life: 3000 });
        }
    };

    handleSetSearchTypeValue = (value) => {
        this.setState({ searchType: value });
    };

    handleSetSearchValue = (value) => {
        this.setState({ searchValue: value }, () => {
            this.debouncedApiCall();
        });
    };

    handleSearchLevel = (value) => {
        this.setState({ searchLevel: value }, this.filterUsersData);
    };
    renderHeader() {
        return (
            <div className="flex justify-content-between align-items-center">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilterValue} onChange={this.onGlobalFilterChange} placeholder="Name / Phone Number" />
                </span>
                {/* <h5 className="m-0">Customers</h5> */}
            </div>
        )
    }
    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let filters = { ...this.state.filters };
        filters['global'].value = value;
        this.setState({ filters, globalFilterValue: value });
    };
    render() {

        const header = this.renderHeader();
        const { changeRequests, isLoading, isDialogOpenForApproveStudent, isRejectTransferDialogOpen, rowData, searchLevel, flagForTransfer } = this.state;

        return (
            <div>
                <div className="ma-main">
                    <div className="datatable-crud-demo ma-m30 mx-2 mb-5">
                        <div className="flex">
                            <div className="flex flex-column justify-content-center align-items-center mt-3">
                                <RadioButton inputId="ingredient1" onChange={() => this.handleSearchLevel(1)} checked={searchLevel === 1} />
                            </div>
                            <div>
                                <BranchToSectionApprovalHierarchy
                                    selectedValue={searchLevel}
                                    setValues={this.setDropdownValues}
                                    approvalType={'studentStatusChange'} />
                            </div>
                        </div>
                        {/* <div style={{ marginLeft: '100px' }} className="flex justify-content-start align-items-center">
                            <span className="">OR</span>
                        </div> */}

                        {/* <div className="flex mt-4">
                            <div className="flex flex-column justify-content-center align-items-center mt-3">
                                <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(2)} checked={this.state.searchLevel === 2} />
                            </div>

                            <div className="field ml-4">
                                <ClassetStudentSearchFilter
                                    selectedValue={this.state.searchLevel}
                                    setValues={this.setDropdownValues}
                                />
                            </div>
                        </div> */}
                        {/* <div className="flex mt-4">
                            <div className="flex flex-column justify-content-center align-items-center -mt-3">
                                <RadioButton inputId="ingredient2" onChange={() => this.handleSearchLevel(2)} checked={searchLevel === 2} />
                            </div>
                            <div className="field ml-4">
                                <ClassetStudentSearch selectedValue={searchLevel} handleTypeValue={this.handleSetSearchTypeValue} handleSearchValue={this.handleSetSearchValue} />
                            </div>
                        </div> */}
                    </div>

                    <div className="card datatable-crud-demo ma-m30 m-2">
                        <DataTable
                            ref={(el) => (this.dt = el)}
                            value={changeRequests}
                            dataKey="id"
                            paginator
                            className="dataTableValuesText"
                            responsiveLayout="scroll"
                            showGridlines
                            columnResizeMode="expand"
                            resizableColumns
                            onPage={this.onPage}
                            first={this.state.lazyParams.first}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            // globalFilter={this.state.globalFilter}

                            selection={this.state.selectedRows}
                            onSelectionChange={this.onSelectionChange}
                            selectionMode="checkbox"


                            // paginator
                            // //filter 
                            lazy={false} // Changed to false for front-end pagination
                            header={header}
                            filters={this.state.filters} filterDisplay="menu" loading={this.state.isLoading}
                            globalFilterFields={[
                                'given_name',
                                'phone_number',

                            ]}
                        >
                            <Column style={{ width: '15rem', height: '6rem' }} alignHeader={'center'} sortable headerClassName="text-color-secondary" bodyClassName="text-center" field="given_name" header="Student Name" />
                            <Column style={{ width: '17rem', height: '6rem' }} alignHeader={'center'} sortable headerClassName="text-color-secondary" bodyClassName="text-center" field="custom:board" header="Board" />
                            <Column filterField="parentContactNo" field="parentContactNo" sortable bodyClassName='text-center' header="Grade-Section" alignHeader={"center"} body={(rowData, { rowIndex }) => {
                                return (

                                    <p>{rowData ? `${rowData?.["custom:grade"]} - ${rowData?.sectionName}` : null}</p>
                                )
                            }} />
                            <Column style={{ width: '15rem', height: '6rem' }} alignHeader={'center'} sortable headerClassName="text-color-secondary" bodyClassName="text-center" field="user_info.parentContactNo" header="Phone Number" />
                            <Column
                                style={{ width: '15rem', height: '6rem' }}
                                alignHeader={'center'}
                                headerClassName="text-color-secondary"
                                bodyClassName="text-center"
                                header="Status"
                                body={(rowData) => (rowData?.status === 'Active' ? <ActiveTag /> : <InactiveTag />)}
                            />
                            <Column
                                style={{ width: '15rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary"
                                bodyClassName="text-center"
                                header="Approve / Reject"
                                body={(rowData) => (
                                    <div className="flex justify-content-evenly">
                                        <div
                                            className="cursor-pointer"
                                            onClick={() =>
                                                this.setState({
                                                    isDialogOpenForApproveStudent: true,
                                                    rowData: rowData,
                                                    branchId: rowData?.tobranchId,
                                                    branchName: rowData?.tobranchName,
                                                    flagForTransfer: 'APROVE'
                                                })
                                            }
                                        >
                                            <GreenCheck />
                                        </div>
                                        <div
                                            className="cursor-pointer"
                                            onClick={() =>
                                                this.setState({
                                                    isRejectTransferDialogOpen: true,
                                                    rowData: rowData,
                                                    branchId: rowData?.tobranchId,
                                                    branchName: rowData?.tobranchName,
                                                    flagForTransfer: 'REJECT'
                                                })
                                            }
                                        >
                                            <CancelRed />
                                        </div>
                                    </div>
                                )}
                            />
                        </DataTable>

                        <Toast ref={(el) => (this.toast = el)} position="bottom-right" />

                        <Dialog
                            visible={isDialogOpenForApproveStudent}
                            style={{ width: 400 }}
                            header={() => (
                                <div className="mt-2 formHeadingInter">
                                    <div className="mb-3">
                                        <PopupGreeTick />
                                    </div>
                                    <p style={{ fontWeight: 'bold', fontSize: 20 }}>Approve Status Change</p>
                                </div>
                            )}
                            footer={() => (
                                <div className="" style={{ display: 'flex' }}>
                                    <Button style={{ borderRadius: 10, backgroundColor: '#076EFF', width: '170%', padding: 0, justifyContent: 'center', alignItems: 'center' }} onClick={() => this.updateTransfer('APROVE')}>
                                        <p className="text-xl ml-2">Accept</p>
                                    </Button>
                                    <Button
                                        style={{ borderRadius: 10, backgroundColor: '#E0E0E0', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', border: 0 }}
                                        onClick={() => this.setState({ isDialogOpenForApproveStudent: false })}
                                    >
                                        <p className="text-xl">Cancel</p>
                                    </Button>
                                </div>
                            )}
                            onHide={() => this.setState({ isDialogOpenForApproveStudent: false })}
                        >
                            <p className="topicName ml-6" style={{ color: 'black', alignSelf: 'center', paddingBottom: 10 }}>
                                <p>Student Name : {rowData?.given_name}</p>
                                <p>Branch Name: {rowData?.branchName}</p>
                                <p>Phone number : {rowData?.parentContactNo}</p>
                                <p>Request Raised by : {rowData?.requestRaisedByName?.slice(3)}</p>
                                {rowData?.user_info?.status === 'Active' ? (
                                    <p style={{ color: 'green' }} className="mt-3">
                                        *Change student status as InActive
                                    </p>
                                ) : (
                                    <p style={{ color: 'green' }} className="mt-3">
                                        *Change student status as Active
                                    </p>
                                )}
                            </p>
                        </Dialog>

                        <Dialog
                            visible={isRejectTransferDialogOpen}
                            style={{ width: 400 }}
                            header={() => (
                                <div className="mt-2 formHeadingInter">
                                    <div className="mb-3">
                                        <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                                    </div>
                                    <p style={{ fontWeight: 'bold', fontSize: 20 }}>Reject Status Change</p>
                                </div>
                            )}
                            footer={() => (
                                <div className="flex justify-content-center ">
                                    <Button className="formSubmitButton px-6" style={{ border: 0 }} onClick={() => this.updateTransfer('REJECT')}>
                                        <p className="formSubmitButtonText">Reject</p>
                                    </Button>
                                    <Button className="formCancelButton px-4" style={{ backgroundColor: '#F4F5F6', border: 0 }} onClick={() => this.setState({ isRejectTransferDialogOpen: false })}>
                                        <p className="formCancelButtonText">Cancel</p>
                                    </Button>
                                </div>
                            )}
                            onHide={() => this.setState({ isRejectTransferDialogOpen: false })}
                        >
                            <p className="topicName ml-6" style={{ color: 'black', alignSelf: 'center', paddingBottom: 10 }}>
                                <p>Student Name : {rowData?.given_name}</p>
                                <p>Branch Name: {rowData?.branchName}</p>
                                <p>Phone number : {rowData?.phone_number}</p>
                                <p>Request Raised by : {rowData?.requestRaisedByName?.slice(3)}</p>
                            </p>
                        </Dialog>
                        {isLoading && <LoadingComponent />}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({
    branchData: (state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each) => each.level === 1)) || []
});

export default connect(mapStatesToProps, {
    getBranchesLatest
})(Authentication(withRouter(StudentStatusChangeRequests)));
